// extracted by mini-css-extract-plugin
export default {"modalSubtitle":"ModalUsedInVersion2_modalSubtitle__dIvm9","badge":"ModalUsedInVersion2_badge__HCIJg"};